<template>
  <div class="cockpitC">
    <div class="maskPanel"></div>
    <div class="cockpitHeader">
      <div class="cockpitHeaderLeft">
        <i class="bellIcon"></i>
        <div class="number">
          咨询总人数
          <strong>{{consultations.peopleTotal | scientificCounting}}</strong> 人
        </div>
      </div>
      <div class="cockpitHeaderTitle">{{cockpitConfig.title || '咨询一体化数字化大屏'}}</div>
      <div class="cockpitHeaderRight">
        <div class="weatherContainer" v-if="cockpitConfig.showWeather">
          <img
            :alt="weatherData.wea"
            :src="getWeatherIcon(weatherData.wea_img)"
            :title="weatherData.wea"
            class="weatherIcon"
          />
          <!-- <i :class="`qi-${weatherData.wea_img || 100}-fill`" :title="weatherData.wea"></i> -->
        </div>
        <div class="dateContainer">
          <div class="menuBtn">
            <div class="time">{{ nowTime }}</div>
          </div>
          <div class="menuBtn">
            <div class="week">{{ weekDate }}</div>
            <div class="date">{{ nowDate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="cockpitContent">
      <div class="cockpitContentLeft">
        <div class="cockpitPanel mb1">
          <div class="cockpitPanelHeader">
            <div class="cockpitPanelTitle">
              <span class="panelTitleBtn active">即时咨询</span>
            </div>
          </div>
          <div class="cockpitPanelContent">
            <div class="scollTable">
              <div class="scollTitle">
                <div class="name">咨询事项</div>
                <div class="time">咨询时间</div>
                <div class="value">咨询类型</div>
              </div>
              <div class="scollBody">
                <vue-seamless-scroll
                  :class-option="classOption"
                  :data="realTime"
                  v-if="realTime && realTime.length > 0"
                >
                  <ul class="keyFocusContaniner">
                    <li :key="idx+'-realTime'" class="scollItem" v-for="(item, idx) in realTime">
                      <div :title="item.item" class="name">{{item.item}}</div>
                      <div class="time">{{formatDate(item.time)}}</div>
                      <div class="value">{{item.type}}</div>
                    </li>
                  </ul>
                </vue-seamless-scroll>
                <ul class="keyFocusContaniner" v-else>
                  <li class="scollItem nodata">暂无数据</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="cockpitPanel">
          <div class="cockpitPanelHeader">
            <div class="cockpitPanelTitle">
              <span
                :class="`panelTitleBtn ${bussiType=='IM'?'active':'pointer'}`"
                @click="changeBussiType('IM')"
                v-if="(cockpitConfig.showData|| []).indexOf('IM') >= 0"
              >即时类型分析</span>
              <span
                :class="`panelTitleBtn ${bussiType=='HL'?'active':'pointer'}`"
                @click="changeBussiType('HL')"
                v-if="(cockpitConfig.showData|| []).indexOf('HL') >= 0"
              >热线类型分析</span>
              <span
                :class="`panelTitleBtn ${bussiType=='MC'?'active':'pointer'}`"
                @click="changeBussiType('MC')"
                v-if="(cockpitConfig.showData|| []).indexOf('MC') >= 0"
              >留言类型分析</span>

              <!-- <span class="panelTitleBtn active">业务类型分析</span> -->
            </div>
          </div>
          <div class="cockpitPanelContent bg">
            <div class="cockpitChartContainer" ref="bussiTypeChart"></div>
          </div>
        </div>
      </div>
      <div class="cockpitContentCenter">
        <div class="cockpitMapTags">
          <div class="cockpitOptionContaner">
            <Select
              @on-change="changeTimeType"
              @on-clear="clearTimeType"
              class="selfCockpitOption"
              style="width: 90px"
              transfer-class-name="selfCockpitOptionTansfer"
              translfer
              v-model="timeType"
            >
              <Option
                :key="item.value"
                :value="item.value"
                v-for="item in timeTypes"
              >{{ item.label }}</Option>
            </Select>
            <DatePicker
              :disabled="timeType!='custom'"
              :editable="false"
              :options="optionsDate"
              @on-change="changeTime"
              @on-clear="clearTime"
              class="selfCockpitOption"
              format="yyyy-MM-dd"
              placeholder="请选择查询时间"
              placement="bottom-end"
              style="width: 220px"
              transfer-class-name="selfCockpitOptionTansfer"
              translfer
              type="daterange"
              v-model="selectDate"
            />
          </div>
          <div class="cockpitMapTagLine">
            <div class="mapTag">
              <div class="mapTagIcon"></div>
              <div class="mapTagContent">
                <div class="mapTagTitle">今日咨询量</div>
                <div class="mapTagValue">{{consultations.dayTotal | scientificCounting}}</div>
              </div>
            </div>
            <div class="mapTag">
              <div class="mapTagIcon"></div>
              <div class="mapTagContent">
                <div class="mapTagTitle">咨询总量</div>
                <div class="mapTagValue">{{consultations.total | scientificCounting}}</div>
              </div>
            </div>
            <div class="mapTag">
              <div class="mapTagIcon"></div>
              <div class="mapTagContent">
                <div class="mapTagTitle">满意率</div>
                <div class="mapTagValue">{{consultations.satisfactionRate}}%</div>
              </div>
            </div>
            <div class="mapTag">
              <div class="mapTagIcon"></div>
              <div class="mapTagContent">
                <div class="mapTagTitle">
                  <Tooltip content="仅统计热线和即时咨询" style="align-items: center;display: flex;">
                    接通率
                    <!-- <Icon size="16" type="md-information" /> -->
                  </Tooltip>
                </div>
                <div class="mapTagValue">{{consultations.accessRate}}%</div>
              </div>
            </div>
          </div>
          <div class="cockpitMapTagLine2">
            <div class="cockpitMapLine2Tag" v-if="(cockpitConfig.showData|| []).indexOf('IM') >= 0">
              <i class="imIcon" />
              <div>
                <div class="title">即时咨询</div>
                <div class="value">{{consultations.imTotal | scientificCounting}}</div>
              </div>
            </div>
            <div class="cockpitMapLine2Tag" v-if="(cockpitConfig.showData|| []).indexOf('HL') >= 0">
              <i class="hotIcon" />
              <div>
                <div class="title">热线咨询</div>
                <div class="value">{{consultations.hotTotal | scientificCounting}}</div>
              </div>
            </div>

            <div class="cockpitMapLine2Tag" v-if="(cockpitConfig.showData|| []).indexOf('MC') >= 0">
              <i class="mcIcon" />
              <div>
                <div class="title">留言咨询</div>
                <div class="value">{{consultations.mcTotal | scientificCounting}}</div>
              </div>
            </div>
            <div
              class="cockpitMapLine2Tag"
              v-if="(cockpitConfig.showData|| []).indexOf('OTHER') >= 0"
            >
              <i class="otherIcon" />
              <div>
                <div class="title">其他咨询</div>
                <div class="value">{{consultations.otherTotal | scientificCounting}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="cockpitMapContainer">
          <div class="regionMapContainer" height="100%" ref="regionMapContainer" width="100%"></div>
          <!-- <div class="mapBtns">
            <div class="mapBtn">总量</div>
            <div class="mapBtn">热线</div>
            <div class="mapBtn">即时</div>
            <div class="mapBtn">留言</div>
          </div>-->
        </div>
      </div>
      <div class="cockpitContentRight">
        <div class="cockpitPanel mb1">
          <div class="cockpitPanelHeader">
            <div class="cockpitPanelTitle">
              <span
                :class="`panelTitleBtn ${consultType=='IM'?'active':'pointer'}`"
                @click="changeConsultType('IM')"
                v-if="(cockpitConfig.showData|| []).indexOf('IM') >= 0"
              >即时咨询量</span>
              <span
                :class="`panelTitleBtn ${consultType=='HL'?'active':'pointer'}`"
                @click="changeConsultType('HL')"
                v-if="(cockpitConfig.showData|| []).indexOf('HL') >= 0"
              >热线咨询量</span>

              <span
                :class="`panelTitleBtn ${consultType=='MC'?'active':'pointer'}`"
                @click="changeConsultType('MC')"
                v-if="(cockpitConfig.showData|| []).indexOf('MC') >= 0"
              >留言咨询量</span>
            </div>
          </div>
          <div class="cockpitPanelContent bg">
            <div class="cockpitChartContainer" ref="consultTypeChart"></div>
          </div>
        </div>
        <div class="cockpitPanel">
          <div class="cockpitPanelHeader">
            <div class="cockpitPanelTitle">
              <span class="panelTitleBtn active">人群类别</span>
            </div>
          </div>
          <div class="cockpitPanelContent bg">
            <div class="cockpitChartContainer" ref="crowTypeChart"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import chinaMap from '@/assets/static/mapJson/china.json'
import zjMap from '@/assets/static/mapJson/330000.json'
import xiongan from '@/assets/static/mapJson/xiongan.json'
export default {
  name: 'cockpit',
  data () {
    let _this = this
    return {
      selectDate: [],
      consultType: '',
      bussiType: '',
      timeType: '',
      cockpitConfig: {},
      timeTypes: [{
        label: '本年',
        value: 'year',
      }, {
        label: '本月',
        value: 'month',
      }, {
        label: '本周',
        value: 'week',
      }, {
        label: '本日',
        value: 'day',
      }, {
        label: '自定义',
        value: 'custom',
      }],
      optionsDate: {
      },
      classOption: {
        // 滚动速度
        step: 0.2,
        // 鼠标悬停停止滚动
        hoverStop: true,
        // 滚动组数
        limitMoveNum: 1,
        // 监听刷新
        openWatch: true
      },
      datetimeInterval: null,
      weekDate: '',
      nowTime: "",
      nowDate: "",
      weatherData: {},
      consultations: {},
      realTime: [],
      echartsbussiTypeChart: null,
      echartsConsultTypeChart: null,
      echartscrowTypeChart: null,
      regionMapChart: null,
      bussinessInfo: {},
      consultationTrend: {},
      crowdInfo: {},
      mapData: {},
      childrenAreaData: [],
      timer: null,
      currentIndex: 0
    }
  },
  methods: {
    clearTimeType: function () {
      this.timeType = 'year'
    },
    changeTimeType: function (val) {
      console.log('changeTimeType', val)
      this.timeType = val
      const date = new Date()
      let year = date.getFullYear()
      switch (val) {
        case 'day':
          let today = this.$moment().format('YYYY-MM-DD')
          this.selectDate = [today, today]
          this.initCockpit()
          break
        case 'week':
          let dayOfWeek = date.getDay()
          let start = this.$moment().subtract(dayOfWeek - 1, 'days').format('YYYY-MM-DD')
          let end = this.$moment().add(7 - dayOfWeek, 'days').format('YYYY-MM-DD')
          this.selectDate = [start, end]
          this.initCockpit()
          break
        case 'month':
          let month = date.getMonth() + 1
          let endMonth = this.$moment().daysInMonth()
          this.selectDate = [year + '-' + month + '-01', year + '-' + month + '-' + endMonth]
          this.initCockpit()
          break
        case 'year':
          this.selectDate = [year + '-01-01', year + '-12-31']
          this.initCockpit()
          break
        default:
          this.selectDate = []
      }
    },
    changeTime: function (val) {
      console.log('changeTime', val)
      // this.staticInit(this.icType, 'time')
      this.initCockpit()
    },
    clearTime: function () {
      this.changeTimeType('year')
    },
    getWeatherIcon: function (iconCode) {
      // return require('@/assets/static/weatherIcons/' + (iconCode || '999') + '.png')
      return require('@/assets/static/weatherIcons/' + (iconCode || '100') + '.png')
    },
    getConfig: function () {
      let _this = this
      this.$axiosH5.post(this.$apis.cockpitApi.getConfig).then(res => {
        if (res.success) {
          _this.cockpitConfig = res.result || {}
        }
      }).catch(err => {
        console.log(err)
        _this.$Message.error("获取配置信息失败！")
      }).finally(() => {
        let typeCode = ''
        if (_this.cockpitConfig.showData && _this.cockpitConfig.showData.length > 0) {
          typeCode = _this.cockpitConfig.showData[0]
        }
        _this.consultType = typeCode
        _this.bussiType = typeCode

        _this.changeTimeType('year')

      })
    },
    loadWeather: function () {
      let _this = this
      if (this.cockpitConfig.showWeather) {
        this.$axiosH5.post(this.$apis.cockpitApi.getWeather).then(res => {
          if (res.success) {
            _this.weatherData = res.result || {}
          }
        }).catch(err => {
          console.log(err)
          _this.$Message.error("获取天气数据失败！")
        })
      }
    },
    destroyChart: function () {
      if (this.regionMapChart != null) {
        this.regionMapChart.dispose()
        this.regionMapChart = null
      }
      if (this.echartsbussiTypeChart != null) {
        this.echartsbussiTypeChart.dispose()
        this.echartsbussiTypeChart = null
      }
      if (this.echartsConsultTypeChart != null) {
        this.echartsConsultTypeChart.dispose()
        this.echartsConsultTypeChart = null
      }
      if (this.echartscrowTypeChart != null) {
        this.echartscrowTypeChart.dispose()
        this.echartscrowTypeChart = null
      }
      if (this.timer) clearInterval(this.timer)
    },
    formatDate: function (date) {
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    getWeek: function (week) {
      switch (week) {
        case 1:
          return '周一'
        case 2:
          return '周二'
        case 3:
          return '周三'
        case 4:
          return '周四'
        case 5:
          return '周五'
        case 6:
          return '周六'
        case 0:
          return '周日'
      }
    },
    getTimeDate: function (focus) {
      this.nowDate = this.$moment().format("YYYY/MM/DD")
      this.nowTime = this.$moment().format("HH:mm")
      this.weekDate = this.getWeek(this.$moment().day())
      let min = this.$moment().minute()
      if (min % 2 == 0 || focus) {
        // 每2分钟刷新一次 或者强制刷新
        this.initCockpit()
      }
    },
    initTestData: function () {
      this.consultations = {
        peopleTotal: Number.parseInt(Math.random() * 10000),
        hotTotal: Number.parseInt(Math.random() * 10000),
        mcTotal: Number.parseInt(Math.random() * 10000),
        otherTotal: Number.parseInt(Math.random() * 10000),
        imTotal: Number.parseInt(Math.random() * 10000),

        dayTotal: Number.parseInt(Math.random() * 10000),
        total: Number.parseInt(Math.random() * 10000),
        satisfactionRate: (Math.random() * 100).toFixed(2),
        accessRate: (Math.random() * 100).toFixed(2),
      }
      // this.realTime = [{
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }, {
      //   name: '农民工被拖欠工资',
      //   time: '2023-10-19 22:35:42',
      //   source: '来电咨询'
      // }]
      this.bussinessInfo = {
        data: [{
          "name": "服务行业",
          "value": Number.parseInt(Math.random() * 10000)
        },
        {
          "name": "法律咨询",
          "value": Number.parseInt(Math.random() * 10000)
        },
        {
          "name": "公证业务",
          "value": Number.parseInt(Math.random() * 10000)
        }]
      }
      this.consultationTrend = {
        xAxis: ['24-01', '24-02', '24-03', '24-04', '24-05', '24-06', '24-07', '24-08', '24-09', '24-10', '24-11'],
        datas: [Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000), Number.parseInt(Math.random() * 10000)]
      }
      this.crowdInfo = {
        totalNum: 3330,
        data: [{
          "name": "农民工",
          "value": Number.parseInt(Math.random() * 10000)
        },
        {
          "name": "退(离)休人员",
          "value": Number.parseInt(Math.random() * 10000)
        },
        {
          "name": "律师",
          "value": Number.parseInt(Math.random() * 10000)
        }, {
          "name": "律师残疾军人",
          "value": Number.parseInt(Math.random() * 10000)
        }]
      }
    },
    setOption () {
      return {
        grid: {
          left: 10,
          right: 10,
          bottom: 10,
          containLabel: true,
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {d}%"
        },
        series: [{
          type: 'pie',
          radius: ['40%', '55%'],
          center: ['50%', '50%'],
          color: this.$common.echartsColor,
          // color: ['#1633F9', '#143DF7', '#0779E9', '#058AE5', '#33DE6C', '#DB4C2A','#EC6A26','#6B03FA','#EB1702'],
          data: this.bussinessInfo.data || [],
          labelLine: {
            normal: {
              show: true,
              // length: 50,
              // length2: 20,
              lineStyle: {
                color: '#106AFF',
                width: 2
              }
            }
          },
          label: {
            normal: {
              formatter: '{d|{d}%}\n{hr|}\n{b|{b}}',
              rich: {
                hr: {
                  borderColor: '#106AFF',
                  width: '100%',
                  borderWidth: 2,
                  height: 0
                },
                d: {
                  color: '#e2edff',
                  fontSize: 22,
                  fontFamily: "Alibaba PuHuiTi",
                  fontStyle: 'normal',
                  fontWeight: 900,
                  letterSpacing: 0.98,
                  align: 'left',
                  // padding: 2
                },
                b: {
                  color: '#e2edff',
                  fontFamily: 'Alibaba PuHuiTi',
                  fontSize: 14,
                  fontStyle: 'normal',
                  fontWeight: 400,
                  letterSpacing: 0.49,
                  align: 'left',
                  padding: 4
                }
              }
            }
          }
        }
        ]
      }
    },
    changeBussiType: function (type) {
      this.bussiType = type
      this.chartInit()
    },
    chartInit () {
      let that = this

      that.bussinessInfo = {}
      if (this.bussiType == undefined || this.bussiType == '') return
      let params = new this.$URLSearchParams()
      params.append('timeType', this.timeType)
      params.append('icType', this.bussiType)
      params.append('startDate', this.$moment(this.selectDate[0]).format('YYYY-MM-DD'))
      params.append('endDate', this.$moment(this.selectDate[1]).format('YYYY-MM-DD'))
      that.$axiosH5.post(this.$apis.cockpitApi.bussinessInfo, params).then(res => {
        that.bussinessInfo = res.result || {}
      }).catch(function (err) {
        that.$Message.error("获取类型分析数据失败！")
      }).finally(() => {
        if (that.echartsbussiTypeChart != null) {
          that.echartsbussiTypeChart.clear()
        } else {
          that.echartsbussiTypeChart = that.$echarts.init(this.$refs.bussiTypeChart)
        }
        that.echartsbussiTypeChart.setOption(that.setOption())
        that.echartsbussiTypeChart.resize()
      })
    },
    changeConsultType: function (type) {
      this.consultType = type
      this.chartCTInit()
    },
    chartCTInit () {
      let that = this
      that.consultationTrend = {}
      if (this.consultType == undefined || this.bussiType == '') return
      let params = new this.$URLSearchParams()
      params.append('timeType', this.timeType)
      params.append('icType', this.consultType)
      params.append('startDate', this.$moment(this.selectDate[0]).format('YYYY-MM-DD'))
      params.append('endDate', this.$moment(this.selectDate[1]).format('YYYY-MM-DD'))
      that.$axiosH5.post(this.$apis.cockpitApi.consultationTrend, params).then(res => {
        that.consultationTrend = res.result || {}
      }).catch(function (err) {
        that.$Message.error("获取咨询量数据失败！")
      }).finally(() => {
        if (this.echartsConsultTypeChart != null) {
          this.echartsConsultTypeChart.clear()
        } else {
          this.echartsConsultTypeChart = this.$echarts.init(this.$refs.consultTypeChart)
        }
        this.echartsConsultTypeChart.setOption(this.setCTOption())
        this.echartsConsultTypeChart.resize()
      })

    },
    setCTOption () {
      // 获取当前月份
      const currentMonth = new Date().getMonth() + 1
      console.log('currentMonth', currentMonth)
      let current = {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 0,
        colorStops: [{
          offset: 0, color: '#A64928' // 0%
        }, {
          offset: 0.1426, color: '#9E4E2D' // 14.26%
        }, {
          offset: 0.2793, color: '#995331' // 27.93%
        }, {
          offset: 0.5331, color: '#A77045' // 53.31%
        }, {
          offset: 0.7117, color: '#C27C4A' // 71.17%
        }, {
          offset: 0.8675, color: '#CC7743' // 86.75%
        }, {
          offset: 1, color: '#D16F3D' // 100%
        }],
        global: false
      }
      let normal = {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 0,
        colorStops: [{
          offset: 0, color: '#1047BC' // 0%
        }, {
          offset: 0.1426, color: '#1043B8' // 14.26%
        }, {
          offset: 0.2793, color: '#1539B1' // 27.93%
        }, {
          offset: 0.5331, color: '#2741CC' // 53.31%
        }, {
          offset: 0.7117, color: '#2E4EE1' // 71.17%
        }, {
          offset: 0.8675, color: '#2B59EA' // 86.75%
        }, {
          offset: 1, color: '#285DEB' // 100%
        }],
        global: false
      }
      return {
        grid: {
          left: 20,
          right: 20,
          bottom: (this.consultationTrend.xAxis || []).length > 12 ? 60 : 20,
          containLabel: true,
        },
        dataZoom: [
          {
            type: 'inside',
          },
          {
            type: 'slider',
            // show: false,
            show: (this.consultationTrend.xAxis || []).length > 12,
            bottom: 15
          }
        ],
        xAxis: [{
          type: "category",
          data: this.consultationTrend.xAxis || [],
          splitLine: {
            show: true,
            lineStyle: {
              color: "#ffffff26",
              width: 1,
              opacity: 0.3,
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff26",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#ffffff26",
              textAlign: "center",
              fontFamily: "Inter",
              fontSize: 10,
              fontStyle: "normal",
              fontWeight: 400,
              letterSpacing: 0.4,
              opacity: 0.6,
            },
          },
        }],
        yAxis: [{
          type: "value",
          axisLabel: {
            textStyle: {
              color: "#ffffff",
              fontFamily: "Inter",
              fontSize: 12,
              fontStyle: "normal",
              fontWeight: 400,
              opacity: 0.9,
            },
            formatter: "{value}",
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#ffffff26",
              width: 1,
              opacity: 0.3,
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff26",
            },
          },
        }],
        series: [{
          type: 'pictorialBar',
          symbolSize: [20, 10],
          symbolOffset: [0, -5],
          symbolPosition: 'end',
          z: 12,
          label: {
            normal: {
              show: false,
              position: "top",
              formatter: "{c}",
            },
          },
          itemStyle: {
            normal: {
              color: (params) => {
                let isCurrent = this.consultationTrend.xAxis[params.dataIndex] == this.consultationTrend.current
                return isCurrent ? current : normal
              },
            },
          },
          data: this.consultationTrend.datas || [],
        },
        {
          name: '',
          type: 'pictorialBar',
          symbolSize: [20, 10],
          symbolOffset: [0, 5],
          itemStyle: {
            normal: {
              color: (params) => {
                let isCurrent = this.consultationTrend.xAxis[params.dataIndex] == this.consultationTrend.current
                return isCurrent ? current : normal
              },
            },
          },
          z: 12,
          data: this.consultationTrend.datas || [],
        },
        {
          name: '',
          type: 'pictorialBar',
          symbolSize: [60, 30],
          symbolOffset: [0, 20],
          z: 10,
          itemStyle: {
            normal: {
              color: 'transparent',
              borderColor: '#14b1eb',
              borderType: 'dashed',
              borderWidth: 5,
            },
          },
        },
        {
          type: 'bar',
          itemStyle: {
            normal: {
              color: (params) => {
                let isCurrent = this.consultationTrend.xAxis[params.dataIndex] == this.consultationTrend.current
                return isCurrent ? current : normal
              },
              opacity: .7,
            },
          },
          barWidth: "20",
          data: this.consultationTrend.datas || [],
        }]
      }
    },
    chartCrowTypeInit () {
      let that = this
      that.crowdInfo = {}
      let params = new this.$URLSearchParams()
      params.append('timeType', this.timeType)
      params.append('startDate', this.$moment(this.selectDate[0]).format('YYYY-MM-DD'))
      params.append('endDate', this.$moment(this.selectDate[1]).format('YYYY-MM-DD'))
      that.$axiosH5.post(this.$apis.cockpitApi.crowdInfo, params).then(res => {
        that.crowdInfo = res.result || {}
      }).catch(function (err) {
        that.$Message.error("获人群类别数据失败！")
      }).finally(() => {
        if (that.echartscrowTypeChart != null) {
          that.echartscrowTypeChart.clear()
        } else {
          that.echartscrowTypeChart = that.$echarts.init(that.$refs.crowTypeChart)
        }
        that.echartscrowTypeChart.setOption(that.setCorwTypeOption())
      })

    },
    setCorwTypeOption () {
      let pieData = this.crowdInfo.data || []
      let pieDataTotal = pieData.reduce((total, item) => total + item.value, 0)
      return {
        title: {
          text: this.$options.filters.scientificCounting(this.crowdInfo.totalNum),
          subtext: '咨询人数',
          textStyle: {
            color: '#ffffff',
            fontFamily: 'Alibaba PuHuiTi',
            fontSize: 28,
            fontStyle: 'normal',
            fontWeight: 700,
            letterSpacing: 4.93
          },
          subtextStyle: {
            color: '#ffffff',
            textAlign: 'center',
            fontFamily: 'Alibaba PuHuiTi',
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: 2.9
          },
          textAlign: 'center',
          left: '29%',
          top: '42%'
        },
        tooltip: {
          trigger: 'item',
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 10,
          containLabel: true,
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          itemGap: 20,
          selectedMode: true,
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          data: this.crowdInfo.legend,
          // borderColor: '#4F9DF5',
          // borderWidth: 1,
          padding: [10, 18],
          borderRadius: 10,
          itemStyle: {
            borderWidth: 1,
            borderType: 'solid',

          },
          textStyle: {
            // borderWidth: 1,
            // padding: [2, 2],
            // borderType: 'solid',
            // borderColor: '#4F9DF5',
            rich: {
              uname: {
                color: '#ffffff',
                textShadow: '16px 28px 46px #0000000d',
                fontFamily: 'Alibaba PuHuiTi',
                fontSize: 14,
                fontStyle: 'normal',
                fontWeight: 500,
              },
              unum: {
                color: '#ffffff',
                textShadow: '16px 28px 46px #0000000d',
                fontFamily: 'Alibaba PuHuiTi',
                fontSize: 14,
                fontStyle: 'normal',
                fontWeight: 500,
                align: 'right'
              }
            }
          },
          formatter (name) {
            var target
            for (var i = 0, l = pieData.length; i < l; i++) {
              if (pieDataTotal == 0) {
                target = '0%'
              } else if (pieData[i].name == name) {
                target = (pieData[i].value / pieDataTotal * 100).toFixed(1) + '%'
              }
            }
            return `{uname|${name}}{unum|${target}}`
          }
        },
        // color: ['#47A2FF ', '#53C8D1', '#59CB74', '#FBD444', '#7F6AAD', '#585247'],
        series: [
          {
            type: 'pie',
            radius: [80, 110],
            center: ['30%', '50%'],
            // padAngle: 1,
            itemStyle: {
              borderRadius: 6
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            // itemStyle: {
            //   borderWidth: 1,
            //   borderColor: 'transparent'
            // },
            data: pieData,
          }
        ]
      }
    },
    loadMapData: function () {
      let that = this
      that.childrenAreaData = []
      let params = new this.$URLSearchParams()
      params.append('startDate', this.$moment(this.selectDate[0]).format('YYYY-MM-DD'))
      params.append('endDate', this.$moment(this.selectDate[1]).format('YYYY-MM-DD'))
      params.append('timeType', this.timeType)
      that.$axiosH5.post(this.$apis.cockpitApi.getMapData, params).then(res => {
        that.mapData = res.result?.mapData || {}
        that.childrenAreaData = res.result?.childrenData || []
      }).catch(function (err) {
        that.$Message.error("获取地图数据失败！")
      }).finally(() => {
        that.initMap()
      })
    },
    initMap: function () {
      let that = this
      if (this.regionMapChart == null) {
        this.regionMapChart = this.$echarts.init(this.$refs.regionMapContainer)
      } else {
        this.regionMapChart.clear()
      }
      if (that.timer) clearInterval(that.timer)
      this.regionMapChart.showLoading()
      this.$echarts.registerMap("chinaMap", { geoJSON: chinaMap })

      let mapType = 'chinaMap'
      if (this.mapData?.areaCode && this.mapData?.geojson) {
        mapType = this.mapData.areaCode
        this.$echarts.registerMap(this.mapData?.areaCode, this.mapData?.geojson)

        // mapType = 'xiongan'
        // this.$echarts.registerMap("xiongan", { geoJSON: xiongan })
      } else {
        // mapType = 'xiongan'
        // this.$echarts.registerMap("xiongan", { geoJSON: xiongan })
      }

      let option = {
        // backgroundColor: "#040b1c",
        backgroundColor: "transparent",
        tooltip: {
          show: true,
          trigger: "item",
          backgroundColor: "rgba(50,50,50,0.6)",
          borderColor: "#FFFFCC",
          textStyle: {
            color: "#ffffff",
          },
          transitionDuration: 0,
          showDelay: 0,
          hideDelay: 0,
          enterable: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          confine: true,
        },
        // visualMap: {
        //   //图例值控制
        //   min: 1,
        //   max: 10,
        //   calculable: true,
        //   show: false,
        //   color: ["#f44336", "#00eaff"],
        //   textStyle: {
        //     color: "#fff",
        //   },
        // },
        geo: {
          scaleLimit: {
            min: 0.7,
            max: 3,
          },
          left: 'center',
          zoom: 1.2,
          map: mapType,
          select: {
            disabled: true
          },
          roam: true, //是否开启鼠标缩放和平移漫游
          label: {
            show: true, //是否显示标签  此处指是否显示地图上的地区名字
            color: '#ffffff',
            fontSize: 12,
            fontWeight: 400
          },
          itemStyle: {
            areaColor: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgba(2, 33, 215, 1)" },
              { offset: 1, color: "rgba(11, 157, 104, 0.05)" },
            ]),
            borderColor: "#00eaff",
            borderWidth: 1,
            shadowColor: 'rgba(0,255,216, 0.4)', //阴影颜色
            shadowBlur: 1,
            shadowOffsetX: -8, //阴影偏移量
            shadowOffsetY: 8, //阴影偏移量
          },
          emphasis: {
            label: {
              show: true,
              color: '#ffffff',
              fontSize: 14,
              fontWeight: 600
            },
            itemStyle: {
              borderWidth: 2,
              borderColor: "#f4ea29",
              areaColor: "rgba(244, 234, 43, 0.3)",//"rgb(17,65,159)",
              shadowColor: 'rgba(244, 234, 43, 0.1)', //阴影颜色
            }
          },

          //     点击的tooltip
          tooltip: {
            show: true,
            formatter: (params) => {
              console.log("tooltip：", params)

              let html = ""
              html += `<div style="color: #fff;font-size: 16px;padding: 12px; text-align: left;
                      background: linear-gradient(180deg, rgba(37,108,233,0.44) 0%, rgba(23,80,169,0.1) 22%, rgba(20,64,137,0) 46%, rgba(16,51,111,0.28) 77%, rgba(30,101,213,0.4) 100%);
                      border-radius: 2px;border: 1px solid;border-image: radial-gradient(circle, rgba(111, 185, 242, 0.86), rgba(0, 0, 0, 0.2)) 1 1;
                      backdrop-filter: blur(10px);">
                        <div>
                          <div style="margin-bottom: 12px">${params.name}(${params.data?.value || 0})</div>
                          <div>`
              if (that.cockpitConfig.showData && that.cockpitConfig.showData.indexOf('HL') >= 0) {
                html += ` <p>
								<span style="font-size: 12px;">热线咨询</span>
								<span style="font-weight: 600;margin-left: 16px;color: #0CC8E6;">${params.data?.hlNum || 0}</span>
							</p>`
              }
              if (that.cockpitConfig.showData && that.cockpitConfig.showData.indexOf('IM') >= 0) {
                html += ` <p>
								<span style="font-size: 12px;">即时咨询</span>
								<span style="font-weight: 600; margin-left: 16px;color: #0CC8E6;">${params.data?.imNum || 0}</span>
							</p>`
              }

              if (that.cockpitConfig.showData && that.cockpitConfig.showData.indexOf('MC') >= 0) {
                html += ` <p>
                <span style="font-size: 12px;">留言咨询</span>
                <span style="font-weight: 600;margin-left: 16px;color: #0CC8E6;">${params.data?.mcNum || 0}</span>
              </p>`
              }

              if (that.cockpitConfig.showData && that.cockpitConfig.showData.indexOf('OTHER') >= 0) {
                html += ` <p>
                <span style="font-size: 12px;">其他咨询</span>
                <span style="font-weight: 600;margin-left: 16px;color: #0CC8E6;">${params.data?.otherNum || 0}</span>
              </p>`
              }

              html += ` </div >
                        </div >
                      </div >`
              return html

            },
          },
        },
        series: [{
          type: "map",
          geoIndex: 0,
          select: {
            disabled: true
          },
          data: that.childrenAreaData || [],
        }
        ],
      }
      this.regionMapChart.setOption(option)
      this.regionMapChart.hideLoading()
      this.autoFn()
      this.timer = setInterval(() => {
        that.autoFn()
      }, 5000)
    },
    autoFn: function () {
      var that = this
      if (this.currentIndex >= this.childrenAreaData.length) {
        this.currentIndex = 0
      }
      let areaName = this.childrenAreaData[this.currentIndex]?.name
      if (this.regionMapChart && areaName) {
        this.childrenAreaData.forEach(item => {
          that.regionMapChart.dispatchAction({
            type: "downplay",
            geoIndex: 0,
            name: item.name,
          })
        })

        this.regionMapChart.dispatchAction({
          type: "highlight",
          geoIndex: 0,
          name: areaName,
        })


        // // 高亮当前图形
        // this.regionMapChart.dispatchAction({
        //   type: "highlight",
        //   seriesIndex: 0,
        //   dataIndex: that.currentIndex,
        // })
        // 显示 tooltip
        this.regionMapChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: that.currentIndex,
        })
        this.currentIndex++
      }
    },
    rs: function () {
      if (this.echartsbussiTypeChart) this.echartsbussiTypeChart.resize()
      if (this.echartsConsultTypeChart) this.echartsConsultTypeChart.resize()
      if (this.echartscrowTypeChart) this.echartscrowTypeChart.resize()
      if (this.regionMapChart) this.regionMapChart.resize()
    },
    initRealTime: function () {
      let that = this
      that.realTime = []
      let params = new this.$URLSearchParams()
      params.append('limitSize', 30)
      that.$axiosH5.post(this.$apis.cockpitApi.realTime, params).then(res => {
        that.realTime = res.result || []
      }).catch(function (err) {
        that.$Message.error("获取即时咨询数据失败！")
      }).finally(() => {
        // that.initMap()
      })
    },
    initTotalData: function () {
      let that = this
      console.log('this.selectDate', this.selectDate)
      that.consultations = {}
      let params = new this.$URLSearchParams()
      params.append('timeType', this.timeType)
      params.append('startDate', this.$moment(this.selectDate[0]).format('YYYY-MM-DD'))
      params.append('endDate', this.$moment(this.selectDate[1]).format('YYYY-MM-DD'))
      that.$axiosH5.post(this.$apis.cockpitApi.consultations, params).then(res => {
        that.consultations = res.result || {}
      }).catch(function (err) {
        that.$Message.error("获取咨询总量数据失败！")
      }).finally(() => {
        // that.initMap()
      })
    },
    initCockpit: function () {
      // this.initTestData()
      this.loadWeather()
      this.initRealTime()
      this.initTotalData()
      this.$nextTick(() => {
        this.loadMapData()
        this.chartInit()
        this.chartCTInit()
        this.chartCrowTypeInit()
      })
    }
  },
  beforeDestroy () {
    try {
      clearInterval(this.datetimeInterval)
      window.removeEventListener("resize", this.rs)
      this.destroyChart()
    } catch (error) {
      console.log('beforeRouteLeave error', error)
    }
  },
  beforeRouteLeave (to, from, next) {
    try {
      clearInterval(this.datetimeInterval)
      window.removeEventListener("resize", () => { })
      this.destroyChart()
    } catch (error) {
      console.log('beforeRouteLeave error', error)
    }
    next()
  },
  beforeMount () {
    this.getConfig()
  },
  mounted () {
    let _this = this
    window.addEventListener('resize', () => {
      _this.rs()
    })
    this.datetimeInterval = setInterval(() => {
      _this.getTimeDate(false)
    }, 60000)


    this.getTimeDate(false)
  }
}
</script>
<style lang="less">
.cockpitC {
  font-family: 'Alibaba PuHuiTi';
  color: #fff;
  background-image: url('./cockpitImages/bg@2x.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  padding: 4px;
  cursor: default;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .maskPanel {
    // 	497∶314
    pointer-events: none;
    background-image: url('./cockpitImages/mapBg.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 5vh;
    width: 52vw;
    height: 40vw;
    margin: auto;
  }

  .cockpitHeader {
    padding: 0 2rem;
    background-image: url('./cockpitImages/header.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    position: relative;
    // overflow-y: hidden;
    height: 8.6vh;
    min-height: 8.6vh;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .cockpitHeaderLeft {
      display: flex;
      width: 35%;
      padding: 12px 0 12px 2.3rem;

      // color: transparent;
      // background: linear-gradient(180deg, #fff 50%, #065fe9 100%);
      // background-clip: text;
      // -webkit-background-clip: text;

      .bellIcon {
        display: block;
        background-image: url('./cockpitImages/bell.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 1.4rem;
        height: 1.4rem;
      }

      flex-shrink: 0;
      fill: linear-gradient(180deg, #ebf2ff 0%, #a0daff 100%);
      filter: drop-shadow(0 0 60px #0cf) drop-shadow(0 0 60px #0cf);

      .number {
        color: #bccdee;
        font-family: 'Alibaba PuHuiTi';
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 1.8px;
        margin-left: 0.5rem;
      }
    }

    .cockpitHeaderTitle {
      text-align: center;
      font-family: 'Alibaba PuHuiTi';
      font-size: 1.82rem;
      font-style: normal;
      font-weight: 700;
      color: transparent;
      // line-height: normal;
      letter-spacing: 3.2px;
      background: linear-gradient(180deg, #fff 50%, #065fe9 100%);
      background-clip: text;
      -webkit-background-clip: text;
      width: 30%;
      max-width: 30%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-bottom: 10px;
    }

    .cockpitHeaderRight {
      width: 35%;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: relative;

      .weatherContainer {
        background: linear-gradient(180deg, #b4c1d9 21.87%, #ebf2ff 80.5%);
        background-clip: text;
        -webkit-background-clip: text;
        color: transparent;

        .weatherIcon {
          width: 4rem;
          // opacity: 0.7;
          position: absolute;
          right: 45%;
          bottom: -1rem;
        }

        > i {
          font-size: 3rem;
        }
      }

      .dateContainer {
        display: flex;
        align-items: center;

        .week,
        .date {
          line-height: 1.2;
          padding: 0 0 0 1.5rem;
          min-width: fit-content;
          text-align: left;
          flex-shrink: 0;
          color: #8fa0c0;
          font-family: 'Alibaba PuHuiTi 2.0';
          font-size: 0.85rem;
          font-style: normal;
          font-weight: normal;
        }

        .time {
          font-family: 'Alibaba PuHuiTi 2.0';
          font-size: 2.2rem;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 6.09px;
          background: linear-gradient(180deg, #b4c1d9 21.87%, #ebf2ff 80.5%);
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          padding: 0 1.7rem;
          border-right: 1px solid #9edaff4d;
        }
      }
    }
  }

  .cockpitHeader::after {
    content: '';
    position: absolute;
    background-image: url('./cockpitImages/headerAfter.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    left: 0;
    position: absolute;
    overflow: hidden;
    pointer-events: none;
    top: 8.6vh;
    z-index: 999;
    // height: 8.6vh;
  }

  .cockpitContent {
    padding: 0 1.72rem 1.6rem 1.72rem;
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    justify-content: space-between;

    .cockpitPanel {
      .cockpitPanelHeader {
        background-image: url('./cockpitImages/panelHeader.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        text-align: left;
        margin-bottom: 12px;
        height: 7.2vh;
        // min-height: 50px;

        .cockpitPanelTitle {
          position: relative;
          padding: 0 1rem;
          white-space: nowrap;
          max-width: 100%;
          overflow: hidden;

          .panelTitleBtn.active {
            // padding: 0;
            background: linear-gradient(180deg, #fff 50%, #065fe9 100%);
            font-style: normal;
            line-height: 8vh;
            background-clip: text;
            letter-spacing: 3px;
            font-weight: 700;
            color: transparent;
            text-shadow: 18px 28px 16px #0e133026, 6px 8px 1px #0042ff33,
              0 0 68px #008aff;
            // font-size: 1.34rem;
            font-size: 1.2rem;
          }

          .panelTitleBtn {
            white-space: nowrap;
            overflow: hidden;
            padding: 0 0.6rem;
            color: #6e809a;
            font-size: 1.05rem;
            font-style: normal;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 2.9px;
          }

          .pointer {
            cursor: pointer;
          }
        }
      }

      .cockpitPanelContent {
        min-height: 100px;
        position: relative;

        .cockpitChartContainer {
          width: 100%;
          height: 100%;
        }
      }

      .cockpitPanelContent.bg {
        background: linear-gradient(180deg, #277cff00 0%, #277cff26 100%);
      }

      .cockpitPanelContent::before {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-image: url('./cockpitImages/panelBottom.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .cockpitPanelContent::after {
        position: absolute;
        content: '';
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-image: url('./cockpitImages/panelBottom.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    .cockpitContentCenter {
      padding: 0 0.9rem;
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      .cockpitMapTags {
        .cockpitOptionContaner {
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }

        .cockpitMapTagLine {
          display: flex;
          justify-content: center;
        }

        .mapTag {
          // display: flex;
          // align-items: center;
          margin: 2.2rem;
          position: relative;
          flex: 1;

          .mapTagIcon {
            background-image: url('./cockpitImages/tagBg.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            justify-content: space-around;
            display: block;
            width: 6.5rem;
            height: 6rem;
            position: absolute;
            bottom: -3rem;
            margin: auto;
            left: 0;
            right: 0;
          }

          .mapTagContent {
            text-align: center;
            font-style: normal;
            line-height: normal;
            // padding: 0 0.6rem;
            text-align: center;

            .mapTagTitle {
              display: flex;
              align-items: center;
              color: #ffffff;
              text-align: center;
              font-size: 0.88rem;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              position: relative;
              width: max-content;
              margin: auto;
              white-space: nowrap;
            }

            .mapTagTitle::before {
              content: '';
              position: absolute;
              background-image: url('./cockpitImages/left.png');
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              width: 4px;
              height: 6px;
              left: -0.5rem;
              margin: auto;
              top: 0;
              bottom: 0;
            }

            .mapTagTitle::after {
              content: '';
              position: absolute;
              background-image: url('./cockpitImages/right.png');
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              width: 4px;
              height: 6px;
              right: -0.5rem;
              margin: auto;
              top: 0;
              bottom: 0;
            }

            .mapTagValue {
              margin-top: 8px;
              color: #ffffff;
              text-align: center;
              text-shadow: 0 4px 4px #00000040;
              font-size: 1.7rem;
              font-style: normal;
              font-weight: 700;
              line-height: normal;

              .unit {
                font-size: 0.75rem;
                font-weight: 400;
              }
            }
          }
        }

        .cockpitMapTagLine2 {
          position: relative;
          margin-top: 2rem;
          display: flex;
          justify-content: center;
          padding: 1rem 2rem;
          // background: #00baf51a;

          .cockpitMapLine2Tag {
            flex: 1;
            overflow: hidden;
            display: flex;
            text-align: center;
            align-items: flex-start;
            justify-content: center;

            .hotIcon,
            .mcIcon,
            .imIcon,
            .otherIcon {
              margin-right: 10px;
              display: inline-block;
              width: 2.4rem;
              height: 2.4rem;
              flex-shrink: 0;
              border-radius: 50%;
              // background: #00baf51a;
              background-position: center;
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }

            .hotIcon {
              background-image: url('./cockpitImages/icon1@2x.png');
            }

            .imIcon {
              background-image: url('./cockpitImages/icon4@2x.png');
            }

            .mcIcon {
              background-image: url('./cockpitImages/icon3@2x.png');
            }

            .otherIcon {
              background-image: url('./cockpitImages/icon2@2x.png');
            }

            .title {
              color: #f7fffd;
              font-size: 13px;
              font-style: normal;
              font-weight: 300;
              text-align: left;
              line-height: normal;
            }

            .value {
              text-align: left;
              font-size: 1.4rem;
              font-style: normal;
              font-weight: 900;
              line-height: normal;
              letter-spacing: 0.91px;

              background: linear-gradient(180deg, #fff 50%, #065fe9 100%);

              background-clip: text;
              color: transparent;
            }
          }
        }

        .cockpitMapTagLine2::after {
          left: 0;
          bottom: 0;
          right: 0;
          height: 60%;
          position: absolute;
          content: '';
          background-image: url('./cockpitImages/centerTagBg.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }

      .cockpitMapContainer {
        flex-grow: 1;
        overflow: hidden;
        position: relative;

        .regionMapContainer {
          width: 100%;
          height: 100%;
        }

        .mapBtns {
          position: absolute;
          right: 1rem;
          top: 1rem;
          border: 1px solid #106aff;
          padding: 2px;
          border-radius: 4px;

          .mapBtn {
            font-size: 12px;
            // scale: (0.9);
            cursor: pointer;
            padding: 4px;
            background-color: rgba(0, 0, 0, 0.1);
          }

          .mapBtn:not(:last-child) {
            border-bottom: 1px solid #106aff;
          }

          .mapBtn:active {
            color: #106aff;
            background-color: rgba(255, 255, 255, 0.05);
          }

          .mapBtn:hover {
            background-color: rgba(255, 255, 255, 0.1);
          }
        }
      }
    }

    .cockpitContentLeft,
    .cockpitContentRight {
      width: 26%;
      display: flex;
      flex-direction: column;
      max-height: 100%;
      height: 100%;
      overflow: hidden;

      .cockpitPanel {
        flex: 1;
        max-height: 50%;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .cockpitPanelContent {
          flex-grow: 1;
          overflow: hidden;
        }
      }
    }

    .mb18 {
      margin-bottom: 1.8rem;
    }
  }

  .scollTable {
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;

    .scollTitle {
      height: 2.4rem;
      flex-shrink: 0;
      border: 1px solid #0a436c5e;
      background: #0071ff0a;

      color: #829fba;
      font-family: 'Alibaba PuHuiTi';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 2.66px;
      display: flex;
      width: 100%;
      text-align: left;
      > div {
        line-height: 2.4rem;
        padding: 0 4px;
      }
    }

    .name {
      width: 35%;
      padding-left: 12px !important;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .time {
      width: 40%;
      flex-grow: 1;
      overflow: hidden;
      text-align: left;
    }

    .value {
      white-space: nowrap;
      // text-align: center;
      width: 25%;
      min-width: fit-content;
    }

    .scollBody {
      flex-grow: 1;
      overflow: hidden;

      .scollItem {
        height: 2.4rem;
        flex-shrink: 0;
        border: 1px solid #0a436c5e;
        background: #0071ff0a;
        margin-bottom: 2px;
        display: flex;
        width: 100%;
        overflow: hidden;

        div {
          text-align: left;
          padding: 0 4px;
          line-height: 2.4rem;
          color: #dbe8f3;
          font-family: 'Alibaba PuHuiTi';
          font-size: 0.8rem;
          font-style: normal;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          // letter-spacing: 2.66px;
        }
      }

      .scollItem.nodata {
        text-align: center;
        color: #dbe8f3;
        font-family: 'Alibaba PuHuiTi';
        font-size: 0.85rem;
        width: 100%;
        display: block;
        line-height: 2.4rem;
      }
    }
  }

  .selfCockpitOption {
    .ivu-select-selection {
      background-color: transparent;
      color: #bccdee;
      border-color: #106aff;
      border-radius: 4px 0 0 4px;
    }

    .ivu-input {
      background-color: transparent;
      color: #bccdee;
      border-radius: 0 4px 4px 0;
      border-color: #106aff;
      border-left: none;
    }

    .ivu-input:hover {
      border-color: #106aff;
    }

    .ivu-icon {
      color: #bccdee;
    }
  }
}
.cockpitC::before {
  content: '';
  pointer-events: none;
  position: absolute;
  background-image: url('./cockpitImages/border.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
}

.selfCockpitOptionTansfer {
  background-color: rgba(28, 30, 41, 1) !important;
  color: #fff;

  .ivu-select-item {
    color: #fff;
  }

  .ivu-select-item-selected,
  .ivu-select-item-selected:hover {
    color: #106aff;
    font-weight: 600;
  }

  .ivu-select-item:hover,
  .ivu-select-item-focus {
    background-color: rgba(255, 255, 255, 0.05);
  }

  .ivu-date-picker-cells-cell-range:before {
    background-color: rgba(255, 255, 255, 0.1);
  }
}
</style>